import { FC, useState } from 'react';

import { IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import { ControlledTextField, ControlledTextFieldProps } from '../ControlledTextField';

export const ControlledPasswordField: FC<ControlledTextFieldProps> = (props) => {
  const { InputProps, sx, multiline, ...rest } = props;
  const [showPassword, setShowPassword] = useState(false);
  const maskedMultilineSx = multiline
    ? [
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        {
          '& textarea': {
            WebkitTextSecurity: showPassword ? 'none' : 'disc',
          },
        },
      ]
    : sx;

  const handleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <ControlledTextField
      {...rest}
      multiline={multiline}
      type={multiline ? 'text' : showPassword ? 'text' : 'password'}
      sx={maskedMultilineSx}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton aria-label="toggle password visibility" onClick={handleShowPassword} edge="end">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default ControlledPasswordField;
